// src/pages/Admin/YearsCreate.js
import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import TitleWithBack from '../../components/common/TitleWithBack';

function YearsCreate() {
  const [name, setName] = useState('');
  const [tooltip, setTooltip] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post('/api/years-of-study', { name });
      setTooltip('Year created successfully!');
      setTimeout(() => navigate('/admin/years/view'), 2000);
    } catch (err) {
      setTooltip('Error creating year.');
    }
  };

  return (
    <div className="container mt-2">
      <TitleWithBack title="Create New Year of Study" />
      <div className="card shadow-sm">
        <div className="card-body">
          <form onSubmit={handleSubmit}>
            <div className="mb-3">
              <label className="form-label">Year of Study</label>
              <input 
                type="text" 
                className="form-control" 
                value={name} 
                onChange={(e) => setName(e.target.value)}
                required
              />
            </div>
            <button type="submit" className="btn btn-primary">Create Year</button>
          </form>
          {tooltip && (
            <div className={`mt-3 alert ${tooltip.startsWith('Error') ? 'alert-danger' : 'alert-success'}`}>
              {tooltip}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default YearsCreate;
